import { mteFetch } from "mte-relay-browser";
import Storage from '../storage';
import Constants from '../constants';

export default class HttpService {
  constructor(baseURL = process.env.REACT_APP_BASE_URL, isOverride = false) {
    this.baseUrl = baseURL;
    this.isOverride = isOverride;
  }

  get defaultHeaders() {
    const currUser = Storage.getItem(Constants.currUserKey);

    if (currUser && currUser.jwt) {
      return {
        'Authorization': `Bearer ${currUser.jwt}`,
        'Content-Type': 'application/json'
      };
    }

    return {
      'Content-Type': 'application/json'
    };
  }

  async request(method, url, data = null, customHeaders = {}) {
    const reqHeaders = { ...this.defaultHeaders, ...customHeaders };

    const fullURL = this.baseUrl + url;

    const requestConfig = {
      method: method,
      headers: reqHeaders
    }

    if (data != null) {
      requestConfig.body = JSON.stringify(data);
    };

    const res = await mteFetch(
      fullURL,
      requestConfig
    );

    // Check to see if the response is of type json; else return type of text
    if (res.headers.get("Content-Type").indexOf("application/json") >= 0) {
      return await res.json();
    } else {
      return await res.text();
    }
  }

  get(url, customHeaders = {}) {
    return this.request('GET', url, null, customHeaders);
  }

  post(url, data, customHeaders = {}) {
    return this.request('POST', url, data, customHeaders);
  }

  put(url, data, customHeaders = {}) {
    return this.request('PUT', url, data, customHeaders);
  }

  delete(url, customHeaders = {}) {
    return this.request('DELETE', url, null, customHeaders);
  }
}